import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../lib/redux/hook.ts'
import { colors } from '../../../ui/colors.ts'
import { EditIcon } from '../../../ui/icons/editIcon.tsx'
import { TrashIcon } from '../../../ui/icons/trashIcon.tsx'
import { ConfirmModal } from '../../../ui/organisms/confirmModal/index.tsx'
import { Dropdown } from '../../../ui/organisms/dropDown/index.tsx'
import { deleteChat, findBrightyChatById, findBrightyChats, getTitle, setAdded, setBrightyIdToDelete, setMenuClosed, setSelectedChat } from './brighty/slice.ts'
import { BreadcrumbsIcon } from '../../../ui/icons/breadcrumbIcon.tsx'
import { SubscriptionTierLimit } from '../../financialAdvisor/dto.ts'
import { keycloak } from '../../../lib/keycloak/index.ts'
import { deleteBotChat, findChatBot, findChatBotById } from './slice.ts'
import { ErrorPopup } from '../../../ui/organisms/errorPopup/index.tsx'
import { setSelectedTab } from '../../financialAdvisor/slice.ts'
import { useNavigate } from 'react-router-dom'

export function BotChatList() {
    const layoutState = useAppSelector(state => state.layout)
    const brightyState = useAppSelector(state => state.brighty)
    const financialAdvisorState = useAppSelector(state => state.financialAdvisor)
    const authState = useAppSelector(state => state.auth)
    const chatState = useAppSelector(state => state.chat)

    const navigate = useNavigate()

    const [isHover, setIsHover] = useState<number | null>(0)
    const [triedToAdd, setTriedToAdd] = useState(false)

    const dispatch = useAppDispatch()

    const fa = keycloak.hasRealmRole('company') ? financialAdvisorState.findByIdFinancialAdvisorResponse! : authState.findMeFinancialAdvisorResponse!

    const chats = brightyState.findBrightyChatResponse ? brightyState.findBrightyChatResponse.messages : { messages: {} }
    const companyChats = chatState.findChatBotResponse ? chatState.findChatBotResponse.messages : { messages: {} }
    const canOpenNewChat = fa ? fa.subscriptionTierLimit !== SubscriptionTierLimit.free ? true : (Object.keys(keycloak.hasRealmRole('company') ? companyChats : chats).length < 10) : false

    useEffect(() => {
        if (brightyState.findBrightyChatResponse && keycloak.hasRealmRole('financial_advisor')) {
            if (brightyState.selectedChat === 0) {
                dispatch(setSelectedChat(Object.keys(brightyState.findBrightyChatResponse.messages).length + 1))
            }
            else {
                dispatch(findBrightyChatById({ id: brightyState.selectedChat.toString() }))
            }
        }

        if (chatState.findChatBotResponse) {
            if (brightyState.selectedChat === 0)
                dispatch(setSelectedChat(Object.keys(chatState.findChatBotResponse.messages).length + 1))
        }
    }, [brightyState.findBrightyChatResponse, chatState.findChatBotResponse])

    useEffect(() => {
        if (brightyState.deleteChatStatus === 'successfully') {
            dispatch(findBrightyChats(brightyState.filters))
        }
        if (chatState.deleteBotChatStatus === 'successfully') {
            dispatch(findChatBot({ ...chatState.filterChatBot, request_user_id: authState.findMeCompanyResponse?.userId!, page_size: 500 }))
        }
    }, [brightyState.deleteChatStatus, chatState.deleteBotChatStatus])

    useEffect(() => {
        if (keycloak.hasRealmRole('company')) {
            dispatch(findChatBotById({ thread_id: brightyState.selectedChat.toString(), user_id: authState.findMeCompanyResponse?.userId! }))
        }
    }, [brightyState.selectedChat])

    return (
        <div style={{ backgroundColor: brightyState.menuClosed ? 'white' : layoutState.theme[50], }} className={clsx(" z-20 pb-4 rounded-l-xl  border-rgba(225, 227, 234, 1) overflow-auto transition-all ease-in-out duration-500",
            {
                " w-[368px] px-4 ": !brightyState.menuClosed,
                "w-0": brightyState.menuClosed
            }
        )}>
            <ErrorPopup cta={keycloak.hasRealmRole('company') ? <></> : <span className=" cursor-pointer text-warning-400 font-semibold text-text-md" onClick={() => {
                dispatch(setSelectedTab(2));
                navigate('/setting')
            }}>Aggiorna il piano</span>} message="Hai raggiunto il numero max. di chat!" active={triedToAdd} close={() => setTriedToAdd(false)} />
            <div className="flex flex-col w-full gap-4 flex-grow">
                <div style={{ overflow: 'auto', height: 'calc(100% - 50px)' }}>
                    <div className=' w-full flex justify-between items-center px-1 py-[22px]'>
                        <div onClick={() => {
                            dispatch(setMenuClosed(!brightyState.menuClosed))
                        }} className={
                            clsx(
                                'transition-all cursor-pointer hover:bg-neutral-200 p-1.5 rounded-xl flex items-center justify-center ',
                                {
                                    'rotate-0 ': !brightyState.menuClosed,
                                    'rotate-180': brightyState.menuClosed,
                                }
                            )
                        }>
                            <BreadcrumbsIcon size={'24'} color={colors.brandSecondary[500]} />
                        </div>
                        {!brightyState.menuClosed && <div onClick={() => {
                            if (!brightyState.written && canOpenNewChat) {
                                dispatch(setAdded(true))
                                dispatch(setSelectedChat(keycloak.hasRealmRole('company') ? (Object.keys(companyChats).length + 1) : Object.keys(chats).length + 1))
                            }
                            else if (!canOpenNewChat) {
                                setTriedToAdd(true)
                            }
                        }} className=' cursor-pointer hover:bg-neutral-200 p-1.5 rounded-xl gap-2 flex flex-row items-center justify-center'>
                            <EditIcon
                                size={'24'} color={colors.brandSecondary[500]} />
                            <span className="text-text-md leading-6 font-medium text-brandSecondary-500">
                                Nuova chat
                            </span>
                        </div>}
                    </div>
                    <div className=' flex flex-col-reverse gap-2'>
                        {
                            (!brightyState.menuClosed && brightyState.findBrightyChatResponse && brightyState.findBrightyChatResponse.messages) && (
                                Object.keys(brightyState.findBrightyChatResponse.messages).map(item =>
                                    <div
                                        id={item}
                                        key={item}
                                        onMouseEnter={() => setIsHover(Number(item))}
                                        onMouseLeave={() => setIsHover(null)}
                                        onClick={() => {
                                            if (!(brightyState.written)) {
                                                if (Number(item) !== brightyState.selectedChat) {
                                                    dispatch(getTitle(item))
                                                    dispatch(findBrightyChatById({ id: item }))
                                                    dispatch(setSelectedChat(Number(item)))
                                                }
                                            }
                                        }}
                                        style={{
                                            borderColor: brightyState.selectedChat === Number(item) ? layoutState.theme[200] : colors.white,
                                            backgroundColor: ((isHover === Number(item) && !brightyState.written) || brightyState.selectedChat === Number(item)) ?
                                                layoutState.theme[100] : layoutState.theme[50],
                                            display: brightyState.getAllTitlesResponse ? brightyState.getAllTitlesResponse.find(elem => elem[2] === item) ? brightyState.getAllTitlesResponse.find(elem => elem[2] === item)![1] ? 'none' : 'block' : 'none' : 'none'
                                        }}
                                        className={clsx("cursor-pointer flex flex-row items-center justify-between w-full gap-3 p-2 rounded-lg", {
                                            "border": brightyState.selectedChat === Number(item)
                                        })}
                                    >
                                        <div className="flex flex-row items-center justify-between gap-3 flex-grow">
                                            <div className="lg:flex flex-col">
                                                <span className="text-text-md leading-6 font-medium text-neutral-800 ">
                                                    {brightyState.getAllTitlesResponse ?
                                                        brightyState.getAllTitlesResponse.find(elem => elem[2] === item) ?
                                                            brightyState.getAllTitlesResponse.find(elem => elem[2] === item)![0] ?
                                                                (brightyState.getAllTitlesResponse.find(elem => elem[2] === item)![0].length <= 25 ?
                                                                    brightyState.getAllTitlesResponse.find(elem => elem[2] === item)![0] :
                                                                    brightyState.getAllTitlesResponse.find(elem => elem[2] === item)![0].substring(0, 24).concat('...')
                                                                ) :
                                                                ('Chat ' + item) : ('Chat ' + item)
                                                        : ('Chat ' + item)
                                                    }
                                                </span>
                                            </div>
                                            <Dropdown items={[
                                                {
                                                    label: 'Cancella',
                                                    icon: <TrashIcon color="" size={""} />,
                                                    onClick: () => {
                                                        dispatch(setBrightyIdToDelete(Number(item)))
                                                    },
                                                    visible: false
                                                }
                                            ]} />
                                        </div>

                                    </div>

                                )
                            )
                        }
                        {
                            (!brightyState.menuClosed && chatState.findChatBotResponse) && (
                                Object.keys(chatState.findChatBotResponse.messages).map(item =>
                                    <div
                                        id={item}
                                        key={item}
                                        onMouseEnter={() => setIsHover(Number(item))}
                                        onMouseLeave={() => setIsHover(null)}
                                        onClick={() => {
                                            if (!(brightyState.written)) {
                                                if (Number(item) !== brightyState.selectedChat) {
                                                    if (!keycloak.hasRealmRole('company'))
                                                        dispatch(getTitle(item))
                                                    dispatch(findChatBotById({ thread_id: item, user_id: brightyState.filters.user! }))
                                                    dispatch(setSelectedChat(Number(item)))
                                                }
                                            }
                                        }}
                                        style={{
                                            borderColor: brightyState.selectedChat === Number(item) ? layoutState.theme[200] : colors.white,
                                            backgroundColor: ((isHover === Number(item) && !brightyState.written) || brightyState.selectedChat === Number(item)) ?
                                                layoutState.theme[100] : layoutState.theme[50],
                                            display: chatState.getAllTitlesResponse ? chatState.getAllTitlesResponse.find(elem => elem[2] === item) ? chatState.getAllTitlesResponse.find(elem => elem[2] === item)![1] ? 'none' : 'block' : 'none' : 'none'
                                        }}
                                        className={clsx("cursor-pointer flex flex-row items-center justify-between w-full gap-3 p-2 rounded-lg", {
                                            "border": brightyState.selectedChat === Number(item)
                                        })}
                                    >
                                        <div className="flex flex-row items-center justify-between gap-3 flex-grow">
                                            <div className="lg:flex flex-col">
                                                <span className="text-text-md leading-6 font-medium text-neutral-800 ">
                                                    {chatState.getAllTitlesResponse ?
                                                        chatState.getAllTitlesResponse.find(elem => elem[2] === item) ?
                                                            chatState.getAllTitlesResponse.find(elem => elem[2] === item)![0] ?
                                                                (chatState.getAllTitlesResponse.find(elem => elem[2] === item)![0].length <= 25 ?
                                                                    chatState.getAllTitlesResponse.find(elem => elem[2] === item)![0].replace('**', '') :
                                                                    chatState.getAllTitlesResponse.find(elem => elem[2] === item)![0].substring(0, 24).concat('...').replace('**', '')
                                                                ) :
                                                                ('Chat ' + item) : ('Chat ' + item)
                                                        : ('Chat ' + item)
                                                    }
                                                </span>
                                            </div>
                                            <Dropdown items={[
                                                {
                                                    label: 'Cancella',
                                                    icon: <TrashIcon color="" size={""} />,
                                                    onClick: () => {
                                                        dispatch(setBrightyIdToDelete(Number(item)))
                                                    },
                                                    visible: false
                                                }
                                            ]} />
                                        </div>
                                    </div>
                                )
                            )
                        }
                    </div>
                </div>
            </div>
            <ConfirmModal open={brightyState.idToDelete !== 0} handleClose={() => {
                dispatch(setBrightyIdToDelete(0))
            }
            } title={'Eliminazione chat'} description={'Vuoi davvero eliminare questa chat?'} labelDeny={'No'} labelConfirm={'Si'}
                actionConfirm={() => {
                    keycloak.hasRealmRole('company') ?
                        dispatch(deleteBotChat(brightyState.idToDelete.toString())) :
                        dispatch(deleteChat(brightyState.idToDelete.toString()))
                    if (brightyState.idToDelete === brightyState.selectedChat) {
                        dispatch(setSelectedChat(Object.keys(keycloak.hasRealmRole('company') ? companyChats : chats).length + 1))
                    }
                    dispatch(setBrightyIdToDelete(0))
                }} />
        </div>
    )
}
